export default function () {
    console.log('in sink');
}



// WEBPACK FOOTER //
// ./Client/app/sink/main/mainCtrl.js